
                export const appVersionDetails =
                {
  "AssemblySemFileVer": "2.3.15.0",
  "AssemblySemVer": "2.3.15.0",
  "BranchName": "hotfix/2.3.12",
  "BuildMetaData": null,
  "CommitDate": "2026-10-15",
  "CommitsSinceVersionSource": 0,
  "EscapedBranchName": "hotfix-2-3-12",
  "FullBuildMetaData": "Branch.hotfix-2.3.12.Sha.fb60d395bbbcb3b74b4986696a70b3732186bd47",
  "FullSemVer": "2.3.15",
  "InformationalVersion": "2.3.15",
  "Major": 2,
  "MajorMinorPatch": "2.3.15",
  "Minor": 3,
  "Patch": 15,
  "PreReleaseLabel": "",
  "PreReleaseLabelWithDash": "",
  "PreReleaseNumber": null,
  "PreReleaseTag": "",
  "PreReleaseTagWithDash": "",
  "SemVer": "2.3.15",
  "Sha": "fb60d395bbbcb3b74b4986696a70b3732186bd47",
  "ShortSha": "fb60d39",
  "UncommittedChanges": 2,
  "VersionSourceSha": "fb60d395bbbcb3b74b4986696a70b3732186bd47",
  "WeightedPreReleaseNumber": 60000
}

                ;
            


// WEBPACK FOOTER //
// ./src/app/appVersionDetails.ts